import { css, keyframes } from 'styled-components';

// Bound the empty menu state without disabling a cohort that hydrates later.
const MENU_LOADING_FALLBACK = '3s';
const revealControl = keyframes`
  from { visibility: hidden; }
  to { visibility: visible; }
`;

export const cohortMenuStyles = css`
  @media (prefers-reduced-motion: no-preference) {
    html[data-top-nav='test'] .controlNav & {
      animation: ${revealControl} ${MENU_LOADING_FALLBACK} step-end;
    }
  }
`;
